// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__3R_m5","Header":"Home_Header__3doH4","Button":"Home_Button__14uJD","social":"Home_social__2bg21","Image":"Home_Image__34gpA","Aboutme":"Home_Aboutme__2wQY1"};